<template>
  <div class="container d-flex py-5 main-container">
    <div class="my-auto w-100 main-area login-area">
      <!-- <h1><img src="./../assets/images/b-logo-3.png" alt="logo" class="img-fluid"></h1> -->
      <div class="row">
        <div class="col-md-12">
          <div class="login-dtl">
            <LogoComponent :header="'パスワードをお忘れの場合'"/>
            <!-- <p>パスワードがわからない場合メールアドレスをご入力ください</p> -->

            <p style="font-size:13px; color:#787878;font-weight:600" class="mb-4">
              ご登録のメールアドレスと生年月日を入力してください。ご登録情報と一致した場合、パスワード再設定のメールをお送りいたします。
            </p>
            <div class="login-form">
              <form @submit.prevent="sendPasswordResetLink">
                <div v-if="other_errors"
                     class="alert alert-danger d-inline-flex" role="alert">
                  {{other_errors.message}}
                </div>
                <div class="custom-form-block">
                  <div class="form-group row">
                    <div class="col-md-12 mb-30">
                      <div class="invalid-feedback" v-if="hasServerError('error_description')">
                        <i class="fa-solid fa-circle-exclamation" style="margin-top:4px;"></i>{{getServerErrorMessage('error_description')}}
                      </div>
                      <label>メールアドレス</label>
                      <div class="input-group custom-group">
                        <input type="text" name="email" class="form-control"
                               v-bind:class="{ 'is-invalid': hasError('email') }"
                               v-model="email"
                               v-validate="'required|email'"
                               data-vv-as="メールアドレス">
                        <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
                        <div class="invalid-feedback" v-if="hasError('email')">
                           {{getErrorMessage('email')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                      <div class="col-lg-12 mb-30">
                        <label class="cstm-label">生年月日</label>
                        <div class="d-flex justify-content-between slct-inline">
                          <select class="form-control"
                                  v-bind:class="{'is-invalid': hasError('year')}"
                                  name="year"
                                  v-model="birth_date.year"
                                  v-validate="'required'"
                                  data-vv-as="生年月日">
                            <!-- <option value="">年</option> -->
                            <option v-for="year in years"
                                    v-bind:key="year" v-bind:value="year">
                              {{year}}
                            </option>
                          </select>
                          <label class="year-label">年</label>
                          <select class="form-control"
                                  v-bind:class="{'is-invalid': hasError('month')}"
                                  name="month"
                                  v-model="birth_date.month"
                                  v-validate="'required'"
                                  data-vv-as="生年月日">
                            <!-- <option value="">月</option> -->
                            <option v-for="month in months"
                                    v-bind:key="month" v-bind:value="month">
                              {{month}}
                            </option>
                          </select>
                          <label class="year-label">月</label>
                          <select class="form-control"
                                  v-bind:class="{'is-invalid': hasError('day')}"
                                  name="day"
                                  v-model="birth_date.day"
                                  v-validate="'required'"
                                  data-vv-as="生年月日">
                            <!-- <option value="">日</option> -->
                            <option v-for="day in days"
                                    v-bind:key="day" v-bind:value="day">
                              {{day}}
                            </option>
                          </select>
                          <label class="year-label">日</label>
                        </div>
                        <div class="invalid-feedback"
                        v-if="hasError('day') || hasError('month') || hasError('year')">
                           
                          生年月日は必須項目です
                        </div>
                          <div class="invalid-feedback"
                        v-if="hasError('birth_date')">
                           
                          <span style="font-size:11.1px">{{getErrorMessage('birth_date')}}</span>
                        </div>
                      </div>
                  </div>
                  <div class="mb-30">
                  </div>
                  <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <button type="submit" class="btn btn-cstm btn-cstm-third btn-cstm-primary">送信</button>
                  </div>
                </div><!-- ends custom-form-block -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div><!-- ends main-area -->
  </div>
</template>
<script>
import moment from 'moment';
import Api from '@/config/api';
import swal from 'sweetalert';
import LogoComponent from './LogoComponent.vue';

export default {
  components: { LogoComponent },
  data() {
    return {
      email: '',
      server_errors: {},
      other_errors: null,
      years: [],
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      days: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      birth_date: {
        year: '',
        month: '',
        day: '',
      },
      final_birth_date: '',
    };
  },
  methods: {
    hasError(field) {
      return (
        field in this.server_errors || this.errors.first(field) !== undefined
      );
    },
    getErrorMessage(field) {
      if (this.errors.first(field) !== undefined) return this.errors.first(field);
      else if (field in this.server_errors) return this.server_errors[field].msg;
      return null;
    },
    hasServerError(field) {
      return !(this.server_errors.data == undefined);
    },
    getServerErrorMessage(field) {
      if (this.server_errors.data == undefined) return null;
      return this.server_errors.data.error_description;
    },
    birthDateChanged() {
      this.final_birth_date = `${this.birth_date.year}-${this.birth_date.month}-${this.birth_date.day}`;
    },
    initBirthDate() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 100; i <= n - 18; i += 1) {
        this.years[j] = i;
        j += 1;
      }
      // const arrayBirthDate = this.formData.birth_date.split('/');
      // console.log(arrayBirthDate);
      // if (arrayBirthDate.length === 3) {
      //   [this.birth_date.year, this.birth_date.month, this.birth_date.day] = arrayBirthDate;
      // }
    },
    async sendPasswordResetLink() {
      try {
        const check = await this.$validator.validate();
        this.server_errors = {};
        if (check) {
          const res = await this.axios({
            method: 'post',
            data: {
              email: this.email,
              birth_date: this.final_birth_date,
            },
            url: Api.url(Api.endpoints.forgotPasswordLink),
          });

          await swal({
            title: '受信メールをご確認ください。'/* 'メールを送信しました。' */,
            text: res.data.message,
            icon: 'warning',
            className: 'custom-swal1',
          });

          this.$router.push({ name: 'login' });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.server_errors = error.response.data;
        } else {
          this.other_errors = error.response.data;
        }
      }
    },
  },
  watch: {
    'birth_date.year': function () {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.month": function () {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    "birth_date.day": function () {
      this.birthDateChanged();
    },
  },
  mounted() {
    this.initBirthDate();
  },
};
</script>
<style scoped>
.year-label {
  display: flex;
  align-items: center;
  font-size: 15px;
  margin-right: 10px;
}
.btn-toolbar {
  display: flex;
  justify-content: flex-start;
}

.btn-cstm {
  /* width: 200px; */
  font-size: 16px;
  border-radius: 4px;
}

.btn-cstm-second {
  background: #787878;
  border: #787878;
}

@media (max-width: 768px) {
  .btn-toolbar {
    flex-wrap: wrap;
  }
}

  label{
    color: #000000
  }
  h2 {
    color: #000000;
  }
  .is-valid  {
    background-image: none;
  }


  .is-invalid {
    background-image: none;
  }

  .form-control {
    border: 1px solid #ced4da !important;
    border-radius: 4px;
    /* background: #f8f9fa !important; */
    padding: 8px;
    margin-right: 10px !important;
  }
</style>
